import { useParams  } from 'react-router-dom';
import Login from '../auth/Login';
import Register from '../auth/Register';
import LostPwd from '../auth/LostPwd';
import Cell from '../components/Cell';
import ChangePwd from '../auth/ChangePwd';

function Authent({setCurrentUser}) {

    const mode = useParams().type;

    const getBloc = () => {
        if (mode === 'login') {
            return (
                <div className='login'>
                    <h1>Vous avez déjà un compte ? </h1>
                    <Login setCurrentUser={setCurrentUser} />
                </div>
            )
        } 
        else if (mode === 'register') {
            return (
                <div className='register'>
                    <h1>Pas de compte ? </h1>
                    <Register setCurrentUser={setCurrentUser} />
                </div>
            )
        }
        else if (mode === 'lostpwd') {
            return (
                <div className='register'>
                    <h1>Mot de passe perdu ?</h1>
                    <LostPwd setCurrentUser={setCurrentUser} />
                </div>
            )
        }
        else if (mode === 'changepwd') {
            return (
                <div className='register'>
                    <h1>Changement de mot de passe</h1>
                    <ChangePwd setCurrentUser={setCurrentUser} />
                </div>
            )
        }
    }
    const bloc = getBloc();

    // Login or Register
    return (
        <>
            <div id='motus_title'>
                <Cell
                key={'1'}
                letter={'M'}
                status={'present'}
                />
                <Cell
                key={'2'}
                letter={'O'}
                status={'absent'}
                />
                <Cell
                key={'3'}
                letter={'M'}
                status={'present'}
                />
                <Cell
                key={'4'}
                letter={'O'}
                status={'absent'}
                />
                <Cell
                key={'5'}
                letter={'M'}
                status={'correct'}
                />
                <Cell
                key={'6'}
                letter={'O'}
                status={'correct'}
                />
                <Cell
                key={'7'}
                letter={'T'}
                status={'correct'}
                />
                <Cell
                key={'8'}
                letter={'U'}
                status={'correct'}
                />
                <Cell
                key={'9'}
                letter={'S'}
                status={'correct'}
                />
            </div>
            <div className='cleared'></div>
            
            {bloc}
        </>
    );
}

export default Authent;